import { createRoute, useNavigate } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { HRSuccessionPlanningPage } from "@/components/hr/hr-succession-planning-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/hr/succession-planning",
  component: HRSuccessionPlanningPageGuard,
});

function HRSuccessionPlanningPageGuard() {
  const { data: session } = useSession();
  const navigate = useNavigate();

  if ((session?.user as { role?: string })?.role !== "admin") {
    navigate({ to: "/my-dashboard" });
    return null;
  }

  return <HRSuccessionPlanningPage />;
}
